import React, { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { WithChildren } from '../../../models/children-props';
import { useLogErrorToServer } from '../../../hooks/useGlobalErrorLogging';
import { Modal } from '../Modal';
import { GlobalError } from '../GlobalError';
import { ClientErrorLogSeverity } from '../../../models/graphql';

export type ErrorBoundaryWrapperViewProps = WithChildren;

const BackupFallbackComponent = ({ error }: { error: Error }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <div>
        <h1>Sorry, something went wrong. Please refresh the page.</h1>
        <hr />
        <em>Error: {error.message}</em>
      </div>
    </div>
  );
};

const ErrorFallback = ({ error }: { error: Error }) => {
  const logErrorToServer = useLogErrorToServer();

  useEffect(() => {
    logErrorToServer.logErrorObject(error, ClientErrorLogSeverity.CRITICAL);
  }, [error, logErrorToServer]);

  return (
    // If the modal has issues, we need a boundary around that.
    <ErrorBoundary FallbackComponent={BackupFallbackComponent}>
      <Modal
        size={'zoom'}
        showCloseIcon={false}
        closeOnClickOutside={false}
        closeOnEsc={false}
        footerContent={undefined}>
        <GlobalError error={error} />
      </Modal>
    </ErrorBoundary>
  );
};
export const ErrorBoundaryWrapperView = ({ children }: ErrorBoundaryWrapperViewProps): JSX.Element => {
  return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
};
